import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AUDITLOGS } from '../../constant';

interface Payload {
  page?: number;
  limit?: number;
  search?: string;
  hospitalId?: string;
  from?: string;
  category?: string;
  severity?: string;
  status?: string;
}

export const getAuditLogsApi = createAsyncThunk(
  'auditLogs/get',
  async (payload: Payload, { rejectWithValue }) => {
    try {
      const requestOptions = {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + getToken(),
        },
        body: JSON.stringify(payload),
      };

      const res = await fetch(
        `${AUDITLOGS.GET_AUDIT_LOGS}?page=${payload?.page}&limit=${payload?.limit}&search=${payload?.search}&hospitalId=${payload?.hospitalId}${payload?.from ? `&from=${payload.from}` : ''}${payload?.category ? `&category=${payload.category}` : ''}${payload?.severity ? `&severity=${payload.severity}` : ''}${payload?.status ? `&status=${payload.status}` : ''}`,
        requestOptions
      );

      if (!res.ok) {
        const errorData = await res.json();
        return rejectWithValue(errorData.msg || 'Failed to fetch Audit Logs');
      }

      const data = await res.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
